export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = `7917e4bb-50c3-46bf-b851-791b7abd35d5`;
export const MODAL_CLOSE_SEC = 2.5;
